import { MasterLinkParams } from '../../Constant'

export const formatMasterLinkParams = (
  localParams: MasterLinkParams,
  incomingParams: MasterLinkParams
) => {
  let params: MasterLinkParams = {}
  if (localParams?.referrerUserId || incomingParams?.referrerUserId) {
    //Local first to prevent overwrite
    params.referrerUserId =
      localParams?.referrerUserId || incomingParams?.referrerUserId || undefined
  }
  //Local first to prevent overwrite
  if (localParams?.pllm_source || incomingParams?.pllm_source) {
    params.pllm_source =
      localParams?.pllm_source || incomingParams?.pllm_source || undefined
  }

  if (incomingParams?.osc || localParams?.osc) {
    //Allow overwrite, use localParams if exists
    params.osc = incomingParams?.osc || localParams?.osc || undefined
  }
  return params
}
